var _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44.508,
    height: 49.273,
    viewBox: "0 0 44.508 49.273",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_56019",
    "data-name": "Group 56019",
    transform: "translate(-360.021 -50.091)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "notification_3_",
    "data-name": "notification (3)",
    transform: "translate(360.021 50.091)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_55670",
    "data-name": "Group 55670",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_85526",
    "data-name": "Path 85526",
    d: "M62.432,36.812a5.707,5.707,0,0,0-5.706-5.023.624.624,0,0,1-.628-.628V21.8A16.383,16.383,0,0,0,45.521,6.517a5.561,5.561,0,0,0,.111-1.089,5.428,5.428,0,1,0-10.856,0,5.811,5.811,0,0,0,.1,1.057,15.882,15.882,0,0,0-10.57,14.973v9.7a.629.629,0,0,1-.628.628,5.7,5.7,0,0,0-5.706,5.023,5.565,5.565,0,0,0,5.539,6.1H33.1a7.149,7.149,0,0,0,14.21,0h9.584a5.565,5.565,0,0,0,5.539-6.1ZM40.2,3.179a2.252,2.252,0,0,1,2.249,2.249,1.943,1.943,0,0,1-.032.3,14.084,14.084,0,0,0-1.637-.151,16.376,16.376,0,0,0-2.8.159,1.943,1.943,0,0,1-.032-.3A2.254,2.254,0,0,1,40.2,3.179Zm0,42.915a3.987,3.987,0,0,1-3.894-3.179H44.1A3.987,3.987,0,0,1,40.2,46.094Zm18.454-7.137a2.365,2.365,0,0,1-1.764.779H23.515a2.366,2.366,0,0,1-1.764-.779,2.335,2.335,0,0,1-.6-1.844,2.5,2.5,0,0,1,2.543-2.146A3.812,3.812,0,0,0,27.5,31.161v-9.7A12.721,12.721,0,0,1,40.2,8.742c.159,0,.31,0,.469.008A13,13,0,0,1,52.92,21.8v9.362a3.812,3.812,0,0,0,3.807,3.807,2.5,2.5,0,0,1,2.543,2.146A2.379,2.379,0,0,1,58.657,38.957Z",
    transform: "translate(-17.95 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85527",
    "data-name": "Path 85527",
    d: "M20.111,57.739a1.587,1.587,0,0,0,1.55-1.248A18.578,18.578,0,0,1,26.716,47.3a1.59,1.59,0,0,0-2.249-2.249,21.746,21.746,0,0,0-5.913,10.768,1.58,1.58,0,0,0,1.208,1.891,1.84,1.84,0,0,0,.35.032Z",
    transform: "translate(-18.44 -38.666)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85528",
    "data-name": "Path 85528",
    d: "M294.477,57.686a1.677,1.677,0,0,0,.342-.04,1.584,1.584,0,0,0,1.208-1.891,21.781,21.781,0,0,0-5.913-10.769,1.59,1.59,0,0,0-2.249,2.249,18.64,18.64,0,0,1,5.054,9.195A1.6,1.6,0,0,0,294.477,57.686Z",
    transform: "translate(-251.639 -38.613)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.5aae3482058f7b66a04a26cb00b7ab41.svg";
export { ForwardRef as ReactComponent };